import { render, staticRenderFns } from "./ProfileBlacklist.vue?vue&type=template&id=74911bd6&"
import script from "./ProfileBlacklist.vue?vue&type=script&lang=js&"
export * from "./ProfileBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports